import {
  getValidCountryCodes,
  countryCodeFound,
  getCountryObjectByCode,
  appendMapTooltip,
  modMap,
  darkenColor,
  markerStyle,
  regionStyle,
  getSpanishCountryName,
  getSpanishRegionName,
  getSpanishMemberStateLabel,
} from "./helper";

jQuery(function ($) {
  if ($("#annualreview-worldmap").length <= 0) { return; }
  console.log("Annual Review worldmap ready");

  var theMap = $("#annualreview-worldmap");

  const markerOverlay = $("#marker-overlay");
  const tip = $(".map-tooltip"); // For click type tooltip
  const tipHover = $(".map-tooltip-hover"); // For hover type tooltip
  const tipCloseButton = $(".map-tooltip-close");

  const pageLang = theMap.data("pagelang");
  const arCountriesData = theMap.data("ar-countries");
  const officesData = theMap.data("offices");
  const msCountriesData = theMap.data("ms-countries");

  const msMarkerCountryCodes = {
    // Barbados
    BB: {
      latLng: [13, -59],
    },
    // Mauritius
    MU: {
      latLng: [-20.2, 57.5],
    },
    // Cape Verde
    CV: {
      latLng: [14.8, -22],
    },
  };
  const msMarkers = msCountriesData.filter((countryData) =>
    msMarkerCountryCodes.hasOwnProperty(countryData.country_code)
  );
  const memberStatesData = msMarkers.map((marker) => {
    const markerData = msMarkerCountryCodes[marker.country_code];
    return {
      ...marker,
      ...markerData,
      style: {
        fill: "#003B7D",
      },
    };
  });
  let mapType = "AR"; // AR = Activity & reach, TH = Themes, MS = Member states
  let activeCountriesData;

  theMap.vectorMap({
    map: "world_mill",
    backgroundColor: "#F9F9FB",
    panOnDrag: true,
    zoomAnimate: true,
    zoomOnScroll: false,
    // markers: officesData,
    markerStyle: markerStyle,
    focusOn: {
      x: 0.5,
      y: 0.5,
      scale: 1,
    },
    regionStyle: regionStyle,
    onRegionClick: function (e, code) {
      // REGION CLICK
      e.preventDefault();
      return false;
    },
    onRegionOver: function (e, code) {
      // REGION HOVER
      e.preventDefault();

      if (countryCodeFound(activeCountriesData, code)) {
        const countryObj = getCountryObjectByCode(activeCountriesData, code);

        let content = {};
        
        content.title = "<strong>" + countryObj.name + "</strong>";
        content.footer = "";

        content.body = [];

        if (mapType === 'AR') {
          if (pageLang === 'es') {
            console.log('es');
            content.body.push({
              text: getTranslation(countryObj.project_classification),
            })
          } else {
            content.body.push({
              text: countryObj.project_classification,
            })
          }
        }

        if (mapType === "MS") {
          if (pageLang === 'es') {
            if (countryObj.field_member_state === "Yes") {
              content.body.push({text: getTranslation('Member State')});
            } else {
              content.body.push({text: getTranslation(countryObj.field_member_state)});
            }
          } else {
            if (countryObj.field_member_state === "Yes") {
              content.body.push({text: 'Member State'});
            } else {
              content.body.push({text: countryObj.field_member_state});
            }
          }
        }

        appendMapTooltip(tipHover, content);
        tipHover.css("position", "fixed");
        tipHover.show();

        e.target.addEventListener("mousemove", tooltipMousemove);
      }

      return false;
    },
    onRegionOut: function (e, code) {
      // REGION OUT
      e.preventDefault();

      tipHover.hide();
      e.target.removeEventListener("mousemove", tooltipMousemove);

      return;
    },
    onRegionTipShow: function (e) {
      e.preventDefault();
      return false;
    },
    onViewportChange: function (e, scale) {
      // console.log('onViewportChange', e.target, 'scale', scale);
    },
    onMarkerTipShow: function (e, label, index) {
      // console.log('e label index', e, label, index);
      e.preventDefault();
    },
    onMarkerClick: function (e, index) {
      // MARKER CLICK
      e.preventDefault();

      return;

      let markerData = officesData;

      if (markerData[index].notClickable === "1") {
        return false;
      }

      if (mapType === "MS") {
        markerData = memberStatesData;
      }

      if (mapType === "MS") {
        const code = markerData[index].country_code;
        regionClickTooltip(e, code, "MS-clicked-tip");
      } else {
        const link = markerData[index].region_permalink;
        window.open(link);
      }
    },
    onMarkerOver: function (e, index) {
      // MARKER HOVER
      e.preventDefault();
      let markerData = officesData;
      let content = {};

      if (mapType === "MS") {
        markerData = memberStatesData;
        content.title = markerData[index].name;
        content.subtitle = markerData[index].region_name;
        content.body = [];
      } else {
        content.title = `${markerData[index].name} ${pageLang === 'es' ? 'oficina' : 'office'}`;
        content.subtitle = markerData[index].region_name;
        content.body = [];
      }

      // if (markerData[index].notClickable !== "1") {
      //   if (pageLang === "es") {
      //     content.footer = "(Haz clic para ver más)";
      //   } else {
      //     content.footer = "(Click to view more)";
      //   }
      // }

      var markerElement = $("circle[data-index=" + index + "]");
      var rect = markerElement[0].getBoundingClientRect();
      var x = rect.left + window.pageXOffset;
      var y = rect.top + window.pageYOffset;

      appendMapTooltip(tip, content);

      tip.css("top", y + "px");
      tip.css("left", x + rect.width / 2 + "px");

      // markerOverlay.fadeIn();
      tip.css("position", "absolute");
      tip.show();

      const countryCode = markerData[index].country_code;

      if (countryCode === null) {
        return;
      }

      myMap.clearSelectedRegions();
      myMap.setSelectedRegions(countryCode);
    },
    onMarkerOut: function (e, index) {
      // MARKER OUT
      e.preventDefault();
      let markerData = officesData;
      if (mapType === "MS") {
        markerData = memberStatesData;
      }

      if (tip.attr("data-tooltip-type") !== "MS-clicked-tip") {
        tip.hide();
      }
      tip.removeAttr("data-tooltip-type");

      const countryCode = markerData[index].country_code;

      if (countryCode === null) {
        return;
      }

      myMap.clearSelectedRegions();
    },
  });
  // theMap.vectormap END ////////////////////////////////////////////////////

  modMap(theMap);

  var myMap = theMap.vectorMap("get", "mapObject");

  // Get highlight color for Activity & Reach type
  function getARRegionColor(pc) {
    switch (pc) {
      case "Active Projects":
        return "#004587";

      case "Inspiring and Supporting Activities":
        return "#398DC8";

      case "Reach":
        return "#95C2E5";

      default:
        return "#C1C7D3";
    }
  }

  function resetAllRegionsFillColor() {
    $.each(myMap.regions, function () {
      $(this)[0].element.setStyle("fill", "#C1C7D3");
    });

    theMap.find("path.jvectormap-region").removeClass("selected");
  }

  // Select/highlight all countries in current map type
  function selectAllCountries(color = "#004587", selectedColor) {
    const validCountryCodes = getValidCountryCodes(
      myMap,
      activeCountriesData
    );

    resetAllRegionsFillColor();

    validCountryCodes.map((country, index) => {
      myMap.regions[country.country_code].element.setStyle("fill", color);
      myMap.regions[country.country_code].element.config.style.selected.fill =
        selectedColor;
      theMap
        .find('path[data-code="' + country.country_code + '"]')
        .addClass("selected");
      // myMap.setSelectedRegions(country.country_code);
    });
  }

  // Map init for Activity & Reach
  function initARMap() {
    const validCountryCodes = getValidCountryCodes(myMap, arCountriesData);

    resetAllRegionsFillColor();

    validCountryCodes.map((country, index) => {
      myMap.regions[country.country_code].element.setStyle(
        "fill",
        getARRegionColor(country.project_classification)
      );
      myMap.regions[country.country_code].element.config.style.selected.fill =
        "#F38336";
      theMap
        .find('path[data-code="' + country.country_code + '"]')
        .addClass("selected");
    });

    activeCountriesData = arCountriesData;
    myMap.addMarkers(officesData);
  }

  // Map init for Member State
  function initMSMap() {
    const validCountryCodes = getValidCountryCodes(myMap, msCountriesData);

    resetAllRegionsFillColor();

    validCountryCodes.map((country, index) => {
      if (country.field_member_state === "Observer") {
        myMap.regions[country.country_code].element.setStyle(
          "fill",
          "#36A0E7"
        );
        myMap.regions[
          country.country_code
        ].element.config.style.selected.fill = darkenColor("#36A0E7", 30);
      } else {
        myMap.regions[country.country_code].element.setStyle(
          "fill",
          "#004587"
        );
        myMap.regions[
          country.country_code
        ].element.config.style.selected.fill = darkenColor("#004587", 30);
      }

      theMap
        .find('path[data-code="' + country.country_code + '"]')
        .addClass("selected");
    });

    activeCountriesData = msCountriesData;
    myMap.addMarkers(memberStatesData);
  }

  // Position map tooltip
  function tooltipMousemove(e) {
    let top = window.pageYOffset || document.documentElement.scrollTop;

    tipHover.css("top", e.pageY - top + "px");
    tipHover.css("left", e.pageX + "px");
  }

  // Map type buttons click event handler, to change map type
  $(".btn-home--map---type").on("click", function () {
    const elm = $(this);
    if (mapType === elm.data("type")) {
      return;
    }

    mapType = elm.data("type");

    $(".btn-home--map---type").removeClass("active");
    elm.addClass("active");

    myMap.clearSelectedRegions();
    myMap.removeAllMarkers();

    tip.hide();

    switch (mapType) {
      case "AR":
        initARMap();
        break;

      // case "TH":
      //   initTHMap();
      //   break;

      case "MS":
        initMSMap();
        break;

      default:
        break;
    }

    $(".map-legend").hide();
    $("#map-legend-" + mapType).show();
  });

  function getTranslation(text) {
    switch (text) {
      case "Active Projects":
        return "Proyectos y programas activos";

      case "Inspiring and Supporting Activities":
        return "Actividades de apoyo";

      case "Reach":
        return "Influencia";

      case "Member State":
        return "Estado miembro";

      case "Observer":
        return "Observador";

      default:
        return text;
    }
  }

  // On page load init map type Activity & Reach
  initARMap();
});
